export default __webpack_public_path__ + "bf0f2b79088eb320e46cf30eedbd2be7.svg";